import { render, staticRenderFns } from "./ad-details.vue?vue&type=template&id=249fc5d5&scoped=true&"
import script from "./ad-details.vue?vue&type=script&lang=js&"
export * from "./ad-details.vue?vue&type=script&lang=js&"
import style0 from "./ad-details.vue?vue&type=style&index=0&id=249fc5d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249fc5d5",
  null
  
)

export default component.exports